export default "__VITE_PUBLIC_ASSET__8f4f1c27__"